import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { HeartHandshake, GraduationCap, Users, Dice5 } from "lucide-react";

const POINTS = [
  { Icon: Dice5, title: "The 8-Round Life Cycle", text: "Players roll through eight rounds of realistic financial decisions across Save, Earn, Invest, Spend and Life Event cards — building intuition through play, not lectures." },
  { Icon: GraduationCap, title: "Built for Real Learners", text: "Designed for adults in community, faith and re-entry programmes. Approachable, jargon-light, and mobile-first so anyone can take part on a phone." },
  { Icon: Users, title: "For Pilot Sponsors & Directors", text: "A credible, measurable financial-literacy experience you can run in workshops, with an AI coach summary that reinforces each learner's takeaways." },
  { Icon: HeartHandshake, title: "Partner With Us", text: "Faith groups, non-profits and educators can integrate Burgeon into existing curricula. Full partner tooling and a video library are on the roadmap." },
];

export const LearnMoreModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="learn-more-modal"
        className="bg-slate-900 border-slate-800 text-slate-100 max-w-lg"
      >
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">About Burgeon</DialogTitle>
          <DialogDescription className="text-slate-400">
            A financial literacy simulation for community empowerment.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          {POINTS.map(({ Icon, title, text }) => (
            <div key={title} className="flex gap-3">
              <div className="w-9 h-9 shrink-0 rounded-lg bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center">
                <Icon className="w-4 h-4 text-emerald-400" />
              </div>
              <div>
                <p className="font-semibold text-slate-100 text-sm">{title}</p>
                <p className="text-sm text-slate-400 leading-relaxed">{text}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-slate-500 mt-2 border-t border-slate-800 pt-3">
          A video learning library and partner inquiry form are coming soon.
        </p>
      </DialogContent>
    </Dialog>
  );
};
